import Vue from 'vue'
import Router from 'vue-router'
import Login from './../views/Login.vue'
import Reg from './../views/Reg.vue'
import NullFind from './../views/404.vue'
import Index from './../views/admin/home/Index.vue'
import BusinessCompany from './../views/business/Company.vue'
import BusinessPerson from './../views/business/Person.vue'
import BusinessWechat from './../views/business/Wechat.vue'
import Goods from './../views/goods/Index.vue'
import GoodsEdit from './../views/goods/Edit.vue'
import GoodsAdd from './../views/goods/Add.vue'
import xpqd from './../views/page/xpqd/Index.vue'
import decoration from './../views/page/decoration/Index.vue'
import Home from './../views/Home.vue'
import Category from './../components/dialog/Category.vue'
import store from './../views/page/store/Index.vue'

Vue.use(Router)
// const nullCom = Vue.component('root', {
//     template: '<router-view></router-view>'
// })

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Login
        },
        {
            path: '/reg',
            component: Reg
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '/404.html',
            component: NullFind
        },
        {
            path: '/index',
            component: Index,
            children: [
                {
                    path: '/',
                    component: Home
                },
                {
                    path: 'business/company',
                    component: BusinessCompany
                },
                {
                    path: 'business/person',
                    component: BusinessPerson
                },
                {
                    path: 'business/wechat',
                    component: BusinessWechat
                },
                {
                    path: 'goods/Index',
                    component: Goods
                },
                {
                    path: 'goods/add',
                    component: GoodsAdd
                },
                {
                    path: 'goods/edit/:id/:type',
                    component: GoodsEdit
                },
                {
                    path: 'goods/Index:sales_status',
                    component: Goods,
                },
                {
                    path: 'goods/Index:review_status',
                    component: Goods,
                },
                {
                    path: 'goods/Index:is_add',
                    component: Goods,
                },
                {
                    path: 'goods/Category',
                    component: Category
                },
                {
                    path: 'page/xpqd/Index',
                    component: xpqd
                },
                {
                    path: 'page/decoration/Index',
                    component: decoration
                },
                {
                  path: 'page/store/Index',
                  component: store
                },
            ]
        },
        {
            path: '*',
            redirect:'/login'
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js